export const opacity = {
  disabled: 0.5,
  muted: 0.7,
  overlay: 0.85,
  statusBarSegment: 1,
} as const;
